import React, { useState } from "react";
import { motion } from "framer-motion";
import styles from "./SlideInImage.module.scss";
const SlideInImage = ({ src, direction, align, text, component }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  // Set animation directions based on props
  const animationConfig = {
    "up-to-down": {
      initial: { opacity: 0, y: -100 },
      whileInView: { opacity: 1, y: 0 },
    },
    "down-to-up": {
      initial: { opacity: 0, y: 100 },
      whileInView: { opacity: 1, y: 0 },
    },
  };

  const alignStyles =
    align === "left"
      ? { marginLeft: 0 }
      : { marginRight: 0, marginLeft: "auto" };

  return (
    <>
      <motion.div
        initial={animationConfig[direction].initial}
        whileInView={animationConfig[direction].whileInView}
        transition={{ duration: 0.3, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.5 }}
        style={{
          ...alignStyles,
          marginTop: "40px",
          display: "flex",
          width: "100%",
          maxWidth: "600px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          borderRadius: "10px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <img
          src={src}
          alt="Slide In"
          style={{
            width: "100%",
            display: "block",
          }}
        />
        {component === "sampleFlats" ? (
          <>
            <div
              className={`${styles.overlay} ${
                isExpanded ? styles.expanded : ""
              }`}
            >
              {isExpanded && <p className={styles.text}>{text}</p>}
            </div>
            <div
              className={`${styles.arrow} ${
                isExpanded ? styles.expandedArrow : ""
              }`}
              onClick={toggleExpand}
            >
              {isExpanded ? "▶" : "◀"}
            </div>
          </>
        ) : (
          <></>
        )}
      </motion.div>
    </>
  );
};

export default SlideInImage;
